import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import {DATE_FORMAT} from '../../../util/messaging/constant';
import util from '../../../util/messaging/utility';
import "./index.css";

export default function ChatWindowDateHeader(
    {dateFormat, currentMessage, previousMessage, nextMessage, containerStyle, wrapperStyle, textStyle, inverted},
    context,
) {
    if (!util.isSameDay(currentMessage, inverted ? previousMessage : nextMessage)) {
        return (
            <div className="direct-messaging-date-header-container" style={containerStyle}>
                <div className="direct-messaging-date-header-wrapper" style={wrapperStyle}>
                    <div className="direct-messaging-date-header-text" style={textStyle}>
                        {moment(currentMessage.createdAt)
                            .locale(context.getLocale())
                            .format(dateFormat)
                            .toUpperCase()}
                    </div>
                </div>
            </div>
        );
    }
    return null;
}

ChatWindowDateHeader.contextTypes = {
    getLocale: PropTypes.func,
};

ChatWindowDateHeader.defaultProps = {
    currentMessage: {
        // TODO: test if crash when createdAt === null
        createdAt: null,
    },
    previousMessage: {},
    nextMessage: {},
    containerStyle: {},
    wrapperStyle: {},
    textStyle: {},
    dateFormat: DATE_FORMAT,
};

ChatWindowDateHeader.propTypes = {
    currentMessage: PropTypes.object,
    previousMessage: PropTypes.object,
    nextMessage: PropTypes.object,
    inverted: PropTypes.bool,
    containerStyle: PropTypes.object,
    wrapperStyle: PropTypes.object,
    textStyle: PropTypes.object,
    dateFormat: PropTypes.string,
};